import { Component, OnInit } from '@angular/core';
import { CommService } from "../../comm.service";



import { Router } from '@angular/router';

@Component({
  selector: 'app-kartaAHistorie',
  templateUrl: './kartaAHistorie.component.html',
  styleUrls: ['../../app.component.css']
})
export class KartaAHistorieComponent implements OnInit{


  today: number = Date.now();
  historieKartaA=[];
  typyPozice=[];

  constructor(private comm: CommService,
    private router:Router){}

  ngOnInit() {
    this.today = setInterval( () => {
           this.today = Date.now();
    }, 1000);
    this.nacteniHistorie();
    this.nacteniPozice();
  }

  getAuthUser() {
    return this.comm.getAuthUser()
  }

  nacteniHistorie(){
    this.comm.getKA_history().subscribe(
      (response) => {
        this.historieKartaA=response.json();
        console.log(this.historieKartaA);
      },
      (error) => console.log(error));
      return this.historieKartaA;
  }

  nacteniPozice(){
    this.comm.getPozice().subscribe(
      (response) => {
        this.typyPozice=response.json();
        console.log(this.typyPozice);
      },
      (error) => console.log(error));
      return this.typyPozice;
  }

}
